<template>
  <!-- <div class="container">
                                    <div class="logo" style="width: 148px">
                                      <img src="../../assets/spr_logo.png" alt="" style="height: 47px">
                                    </div>
                                    <div class="phone">
                                      <img class="img" src="../../assets/icon_phone.png" alt="">
                                      <div class="text">
                                        <p class="title">服务热线</p>
                                        <p class="number">400-618-0755</p>
                                      </div>
                                    </div>
                                    <div class="address">
                                      <p>地址：深圳市福田区八卦四路430大厦四楼401室</p>
                                      <p>Copyright © 深圳前海高扬科技有限公司 粤ICP备19007655号</p>
                                    </div>
                                    <div class="email">
                                      <p>
                                        <img src="../../assets/icon_query.png" alt="">
                                        <span>快递查询</span>
                                      </p>
                                      <p>
                                        <img src="../../assets/icon_mail.png" alt="">
                                        <span>客服邮箱：atm@atmmall.net</span>
                                      </p>
                                    </div>
                                    <div class="icon">
                                      <img src="../../assets/icon_aq.jpg" alt="">
                                      <img src="../../assets/icon_jb.jpg" alt="">
                                    </div>
                                  </div> -->
  <div class="footer-bottom1 footer-a">
    <div class="wh1200">
      <div class="footer-content1 footer-border">
        <a href="http://www.spr-atm.com/" target="_black"
          ><img src="../../assets/spr_logo.png" alt="前海高扬"
        /></a>
      </div>
      <div class="footer-content1 footer-content2 footer-border">
        <img
          src="../../assets/icon_phone.png"
          alt="phone"
          class="footer-img1"
        />
        <span class="footer-font2"
          >服务热线
          <br />
          <span class="footer-font1">0755-82405890</span>
        </span>
      </div>
      <div class="footer-content1 footer-content2 footer-border">
        <span class="footer-font3"
          >地址：西丽街道沙河西路3011号白沙新兴产业园1号楼 <br />Copyright ©
          深圳前海高扬科技有限公司
          <a href="https://beian.miit.gov.cn" target="_blank">
            粤ICP备19007655号
          </a>
        </span>
      </div>
      <div class="footer-content1 footer-content2 footer-border">
        <span class="footer-font4">
          <img src="../../assets/icon_query.png" alt="" />
          <a href="http://www.kuaidi100.com/sz/" target="_blank">快递查询</a>
        </span>
        <br />
        <span class="footer-font4">
          <img src="../../assets/icon_mail.png" alt="" />客服邮箱：
          <a href="mailto:atm8123@spr-atm.com">atm8123@spr-atm.com</a>
        </span>
      </div>
      <div class="footer-content1 footer-content2">
        <span class="footer-img1">
          <a
            href="http://61.144.227.239:9003/webrecord/form_query.jsp"
            target="_blank"
          >
            <img src="../../assets/icon_aq.jpg" alt="国际联网备案验证" />
          </a>
        </span>
        <span class="footer-img1">
          <a href="http://61.144.227.239:9002/" target="_blank">
            <img src="../../assets/icon_jb.jpg" alt="网上报警" />
          </a>
        </span>
        <span id="footerEbsBox" class="footer-img2"> </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    // 获取index.html中的市场监督电子标识DOM
    let script = document.getElementById('ebs')
    script.setAttribute('style', 'width:36px;height:42px;display:show')
    // 添加到底部文字中
    document.getElementById('footerEbsBox').appendChild(script)
  },
}
</script>

<style lang="less" scoped>
.wh1200 {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.wh1200:after {
  clear: both;
  content: ' ';
  display: block;
  height: 0;
  visibility: hidden;
  font-size: 0;
}

.footer-menu {
  padding: 30px 0 25px 0;
}

.footer-menu dl {
  width: 20%;
  float: left;
  padding-left: 10%;
}

.footer-menu dl:first-child {
  padding-left: 0;
}

.footer-menu dl:nth-of-type(2) {
  padding-left: 5%;
}

.footer-menu dl:nth-of-type(3) {
  padding-left: 8%;
}

.footer-menu dl:last-child {
  padding-left: 14%;
}

.footer-menu dt {
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: normal;
}

.footer-menu dd {
  line-height: 20px;
  font-size: 12px;
}

.footer-menu dd a {
  color: #666;
}

.footer-menu dd a:hover {
  color: #00aeef;
}

.footer-bottom1 {
  background: #475669;
  padding: 26px 0;
}

.footer-content1 {
  padding-right: 28px;
  height: 51px;
  float: left;
  color: #fff;
  font-size: 12px;
}

.footer-a a {
  color: #fff;
}

.footer-a a:hover {
  color: #00aeef;
}

.footer-content2 {
  padding: 0 22px;
}

.footer-border {
  border-right: dashed 1px #85919f;
}

.footer-border span {
  vertical-align: middle;
}

.footer-query {
  padding-right: 12px;
}

.footer-content1 img {
  vertical-align: top;
}

.footer-content1:last-child {
  float: right;
  padding: 0;
}

.footer-img1 {
  padding-top: 6px;
  padding-right: 10px;
}

.footer-img2 {
  background-color: #fff;
}

.footer-font1 {
  font-size: 24px;
}

.footer-font2 {
  padding-top: 6px;
}

.footer-font3 {
  padding-top: 6px;
  line-height: 22px;
}

.footer-font4 {
  line-height: 25px;
}

.footer-font4 img {
  padding-right: 10px;
  vertical-align: middle;
}

.footer-record {
  line-height: 30px;
  background: #212831;
  text-align: center;
  font-size: 12px;
}

.footer-record img {
  vertical-align: middle;
  width: 18px;
  height: 18px;
  margin-right: 5px;
}
.page-footer {
  border-top: solid 2px #fff;
}
</style>

<style lang="less" scoped>
// .container {
//   display: flex;
//   flex-direction: row;
//   justify-content: start;
//   align-items: stretch;
//   padding: 14px 0;
//   &>div {
//     border-right: 1px dashed #788696;
//     &:last-child {
//       border-right: none;
//     }
//   }
//   .phone {
//     padding-left: 28px;
//     padding-top: 4px;
//     width: 270px;
//     position: relative;
//     box-sizing: border-box;
//     .img {
//       float: left;
//       margin-right: 20px;
//     }
//     .text {
//       float: left;
//     }
//     .title {
//       margin: 0;
//       font-size: 12px;
//       font-family: "MicrosoftYaHei";
//       color: rgb(255, 255, 255);
//       line-height: 1.5;
//     }
//     .number {
//       margin: 0;
//       font-size: 24px;
//       font-family: "Arial";
//       color: rgb(255, 255, 255);
//       line-height: 1;
//     }
//   }
//   .address {
//     padding: 0 36px;
//     p {
//       margin: 0;
//       line-height: 24px;
//       font-size: 12px;
//       font-weight: bold;
//       font-family: "MicrosoftYaHei";
//       color: rgb(233, 244, 255);
//     }
//   }
//   .email {
//     padding: 0 36px;
//     img {
//       vertical-align: middle;
//       margin-right: 8px;
//     }
//     p {
//       margin: 0;
//       line-height: 24px;
//       font-size: 12px;
//       font-weight: bold;
//       font-family: "MicrosoftYaHei";
//       color: rgb(233, 244, 255);
//     }
//   }
//   .icon {
//     padding-left: 22px;
//     img:first-child {
//       margin-right: 10px;
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// Footer.vue?6b628dd8